import { render, staticRenderFns } from "./MetalPricingInSettleStorageHistory.vue?vue&type=template&id=bba7ce3c&scoped=true&"
import script from "./MetalPricingInSettleStorageHistory.vue?vue&type=script&lang=js&"
export * from "./MetalPricingInSettleStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./MetalPricingInSettleStorageHistory.vue?vue&type=style&index=0&id=bba7ce3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba7ce3c",
  null
  
)

export default component.exports